
class InvoiceDetailHeaderView extends DocumentDetailHeaderView
{
    protected maturityDropdown:MUIButton = null;
    protected maturityLabel:MUILabel = null;
    protected legalAccountNumberLabel:MUILabel = null;
    protected legalEntityLabel:MUILabel = null;
    protected legalEntityDropdown:MUIButton = null;
    protected nextDocumentIDLabel:MUILabel = null;
    protected accountingDateTextField:MUITextField = null;
    protected accountingDateButton:MUIButton = null;
    protected accountingDateLabel:MUILabel = null;

    awakeFromHTML(){
        super.awakeFromHTML();

        // the date the purchase invoice is booked in the accounts (only purchase invoices show it)
        this.accountingDateTextField = MUIOutlet(this, "accounting-date-tf", "MUITextField");
        if (this.accountingDateTextField) this.accountingDateTextField.setOnChangeText(this, function(this:InvoiceDetailHeaderView, control:MUITextField, value:string){
            if (!(this._document instanceof PurchaseInvoice)) return;
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            this._document.accountingDate = value != null && value.length > 0 ? ad.dateFormatter.dateFromString(value) : null;
        });
        this.accountingDateButton = MUIOutlet(this, "accounting-date-btn", "MUIButton");
        if (this.accountingDateButton) this.accountingDateButton.setAction(this, function(this:InvoiceDetailHeaderView){
            let dp = new MUIDatePickerController();
            dp.init();
            dp.delegate = this.accountingDatePickerDelegate;
            dp.modalPresentationStyle = MUIModalPresentationStyle.Popover;
            let pc = dp.popoverPresentationController;
            pc.sourceRect = this.accountingDateButton.frame;
            pc.sourceView = this.accountingDateButton;
            AppHelper.sharedInstance().presentViewController(dp, true);
        });
        this.accountingDateLabel = MUIOutlet(this, "accounting-date-lbl", "MUILabel");

        this.legalAccountNumberLabel = MUIOutlet(this, "le-account-number-lbl", "MUILabel");
        this.legalEntityLabel = MUIOutlet(this, "legal-entity-lbl", "MUILabel");
        this.nextDocumentIDLabel = MUIOutlet(this, "next-document-id-lbl", "MUILabel");

        // the supplier or client as a dropdown while the invoice can be edited: the detail view says what it opens
        this.legalEntityDropdown = MUIOutlet(this, "legal-entity-dd", "MUIButton");
        if (this.legalEntityDropdown) this.legalEntityDropdown.setAction(this, function(this:InvoiceDetailHeaderView){
            if (this.legalEntityAction != null) this.legalEntityAction.call(this.legalEntityTarget);
        });

        this.maturityDropdown = MUIOutlet(this, "maturity-dd", "MUIButton");
        if (this.maturityDropdown) this.maturityDropdown.setAction(this, this.showTemplateSelector);
        this.maturityLabel = MUIOutlet(this, "maturity-lbl", "MUILabel");

        if (this.processButton != null) this.processButton.setAction(this, this.showProcessAlert);
    }

    private legalEntityTarget:any = null;
    private legalEntityAction:any = null;
    /// What the supplier or client dropdown does when pressed (choosing another one).
    setLegalEntityAction(target:any, action:any){
        this.legalEntityTarget = target;
        this.legalEntityAction = action;
    }

    /// The process button of the top bar: process the invoice, or unprocess it once processed.
    processButtonDidPress(){
        this.showProcessAlert();
    }

    private showTemplateSelector(){
        let vc = InstallmentTemplateSelectViewController.newInstance();
        vc.invoice = this._document as Invoice;
        vc.completionTarget = this;
        vc.completionBlock = this.updateMaturity;

        vc.modalPresentationStyle = MUIModalPresentationStyle.Popover;
        let pc = vc.popoverPresentationController;
        pc.sourceRect = this.maturityDropdown.frame;
        pc.sourceView = this.maturityDropdown;

        AppHelper.sharedInstance().presentViewController(vc, true);
    }

    set document(item:Invoice) {
        this.setDocument(item);

        if (this.documentNumberLabel) this.documentNumberLabel.text = item.documentNumber;
        if (item instanceof PurchaseInvoice) {
            if (this.referenceLabel) this.referenceLabel.text = item.externalReference;
            if (this.referenceTextField) this.referenceTextField.text = item.externalReference;
        }
        this.showAccountingDate();

        let legalEntity = item.legalEntity as any;
        if (this.legalAccountNumberLabel) this.legalAccountNumberLabel.text = legalEntity != null ? legalEntity.accountNumber : null;
        if (this.legalEntityLabel) this.legalEntityLabel.text = legalEntity != null ? legalEntity.name : null;
        if (this.legalEntityDropdown) this.legalEntityDropdown.title = legalEntity != null ? legalEntity.name : null;

        let maturity = item.paymentInstallmentTemplateName != null ? item.paymentInstallmentTemplateName : MIOLocalizeString("DIRECT", "DIRECT");
        if (this.maturityDropdown) this.maturityDropdown.title = maturity;
        if (this.maturityLabel) this.maturityLabel.text = maturity;
    }

    private showAccountingDate(){
        let date = this._document instanceof PurchaseInvoice ? this._document.accountingDate : null;
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let text = date != null ? ad.dateFormatter.stringFromDate(date) : null;
        if (this.accountingDateTextField) this.accountingDateTextField.text = text;
        if (this.accountingDateLabel) this.accountingDateLabel.text = text;
    }

    // The calendar of the accounting date: the base class's picker belongs to the invoice date.
    private _accountingDatePickerDelegate:any = null;
    private get accountingDatePickerDelegate() : any {
        if (this._accountingDatePickerDelegate == null) {
            let header = this;
            this._accountingDatePickerDelegate = {
                didSelectDate: function(controller:MUIDatePickerController, date:Date) {
                    if (!(header._document instanceof PurchaseInvoice) || date == null) return;
                    header._document.accountingDate = date;
                    header.showAccountingDate();
                }
            };
        }
        return this._accountingDatePickerDelegate;
    }

    protected setupReferenceTextField( textField:MUITextField ){
        if (textField == null) return;

        textField.setOnChangeText(this, function(this:InvoiceDetailHeaderView, control:MUITextField, value:string){            
            (this._document as PurchaseInvoice).externalReference = value;
        });
    }

    private updateMaturity(maturity:PaymentInstallmentTemplate) {
        let name = maturity != null ? maturity.name : MIOLocalizeString("DIRECT", "DIRECT");
        if (this.maturityDropdown) this.maturityDropdown.title = name;
        if (this.maturityLabel) this.maturityLabel.text = name;
        (this._document as Invoice).paymentInstallmentTemplateName = maturity != null ? maturity.name : null;
        (this._document as Invoice).paymentInstallmentTemplate = maturity;
    }

    protected showProcessAlert(){
        if (this._document.status != DBDocumentStatus.processed) {
            let incomplete = InvoiceDetailHeaderView.incompleteLines(this._document);
            if (incomplete.length > 0) { this.showIncompleteLines(incomplete); return; }
            this.showProcessOptions();
        } 
        else 
        {
            let avc = new MUIAlertViewController();
            avc.initWithTitle(MIOLocalizeString("WARNING", "WARNING"), MIOLocalizeString("ARE_YOU_SURE_YOU_WANT_TO_UNPROCESS_THIS_DOCUMENT?", "ARE YOU SURE YOU WANT TO UNPROCESS THIS DOCUMENT?"), MUIAlertViewStyle.Default);
            avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("UNPROCESS", "UNPROCESS"), MUIAlertActionStyle.Destructive, this, function(this:InvoiceDetailHeaderView){
                this.unprocessInvoice();
            }));
            avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));
            AppHelper.sharedInstance().presentViewController(avc, true);
        }
    }

    // A purchase invoice is processed only when every line is linked to a product or a
    // concept item and has its VAT: the lines that are not, with what they lack. The lines
    // are the document's unless given (the detail view passes the ones it shows).
    static incompleteLines(document:DBCoreDocument, lines:any[] = null) : string[] {
        if (!(document instanceof PurchaseInvoice)) return [];
        let problems:string[] = [];
        for (let l of (lines ?? (document as any).lines?.allObjects ?? []) as any[]) {
            if (!(l instanceof InvoiceLine)) continue;
            let line = l as InvoiceLine;
            let lacks:string[] = [];
            if (line.product == null && line.conceptItem == null) lacks.push(MIOLocalizeString("NO_PRODUCT_OR_CONCEPT", "no product or concept"));
            if (line.vat == null) lacks.push(MIOLocalizeString("NO_VAT", "no VAT"));
            if (lacks.length > 0) problems.push((line.concept ?? "?") + ": " + lacks.join(", "));
        }
        return problems;
    }

    // How many lines lack a product or concept item, and how many lack their VAT (purchase invoices).
    static incompleteCounts(document:DBCoreDocument, lines:any[] = null) : { noProduct:number, noVat:number } {
        let counts = { noProduct: 0, noVat: 0 };
        if (!(document instanceof PurchaseInvoice)) return counts;
        for (let l of (lines ?? (document as any).lines?.allObjects ?? []) as any[]) {
            if (!(l instanceof InvoiceLine)) continue;
            if (l.product == null && l.conceptItem == null) counts.noProduct++;
            if (l.vat == null) counts.noVat++;
        }
        return counts;
    }

    private showIncompleteLines(problems:string[]){
        let shown = problems.slice(0, 8);
        let message = MIOLocalizeString("EVERY_LINE_NEEDS_A_PRODUCT_OR_CONCEPT_AND_A_VAT", "Every line needs a product or a concept item, and a VAT.") + "<br><br>"
                    + shown.map(t => t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")).join("<br>")
                    + (problems.length > shown.length ? "<br>(+" + (problems.length - shown.length) + ")" : "");
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("THE_INVOICE_CANNOT_BE_PROCESSED", "THE INVOICE CANNOT BE PROCESSED"), message, MUIAlertViewStyle.Default);
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, null, null));
        AppHelper.sharedInstance().presentViewController(avc, true);
    }

    protected showProcessOptions(){

        let avc = new MUIAlertViewController();
        avc.initWithTitle( MIOLocalizeString("OPTIONS", "OPTIONS"), MIOLocalizeString("SELECT_OPTIONS", "SELECT OPTIONS"), MUIAlertViewStyle.Default );

        avc.addComboBoxWithConfigurationHandler( this, function(this:InvoiceDetailHeaderView, control:MUIComboBox) {
            DBHelper.sharedInstance().addObserverForEntity(avc, "PayMethod", null, null, null, (objects) => {
                control.removeAllItems();
                let selected = this.lastPayMethod();
                let selectedIndex = -1;
                for (let i = 0; i < objects.length; i++) {
                    control.addItem(objects[i].name, i);
                    if (selected != null && objects[i].identifier == selected.identifier) selectedIndex = i;
                }
                if (selectedIndex >= 0) control.selectItem(selectedIndex);
            });
        });

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, this, function(this:InvoiceDetailHeaderView) {
            let index = avc.comboBoxes[0].getSelectedItem();
            let pm = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc, index, 'PayMethod') as PayMethod;

            this.processDocument( pm );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        avc.addCompletionHandler(this, function () {
            // Release the observers
            DBHelper.sharedInstance().removeObserverForChangesInEntity(avc, 'PayMethod');
        });

        AppHelper.sharedInstance().presentViewController( avc, true );
    }

    protected processDocument( context:any ) {
        let paymethod = context as PayMethod;

        // Push any pending invoice edits first: the hook server computes the installments
        // from the saved data when the status change reaches it.
        DBHelper.saveMainContextWithCompletion(this, function(this:InvoiceDetailHeaderView){
            let ws = (MUIWebApplication.sharedInstance().delegate as AppDelegate).webService;

            // The server validates and changes the status. It returns an error when
            // another user already changed it.
            ws.processInvoice(this._document as Invoice, paymethod, (json:any, error:string) => {
                if (error != null) {
                    AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR", "ERROR"), error);
                    return;
                }

                let invoice = this._document as Invoice;
                invoice.payMethod = paymethod;
                invoice.status = DBDocumentStatus.processed;
                DBHelper.saveMainContext();
            });
        });
    }

    private unprocessInvoice() {
        let ws = (MUIWebApplication.sharedInstance().delegate as AppDelegate).webService;

        ws.unprocessInvoice(this._document as Invoice, (json:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR", "ERROR"), error);
                return;
            }

            this._document.status = DBDocumentStatus.unprocessed;
            DBHelper.saveMainContext();
        });
    }

    // The pay method of the last pending installment, so processing again offers
    // the same pay method the installment already has.
    private lastPayMethod():PayMethod {
        let invoice = this._document as Invoice;

        if (invoice.paymentInstallments != null) {
            for (let ins of invoice.paymentInstallments.allObjects as PaymentInstallment[]) {
                if (ins.status == PaymentInstallmentStatus.pending && ins.paymentMethod != null) return ins.paymentMethod;
            }
        }

        return invoice.payMethod;
    }

    // protected processStockNote(){
    //     //check that stock note exists
    //     if (this.stockNote == null) {
    //         return;
    //     }

    //     //check that the stock note has lines ("El Documento esta Vacío, Añade una Línea")
    //     if (this.stockNote.lines.length <= 0) {
    //         AppHelper.showErrorMessage(null, "INFO", "CAN PROCESS AN EMPTY DOCUMENT");
    //         return;
    //     }

    //     let sectionID = StockNote.sectionIDFromStockNote( this.stockNote );
    //     if (sectionID == null) return;

    //     let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
    //     let section = DBHelper.queryObject(ad.managedObjectContext, "ManagerSection", MIOPredicate.predicateWithFormat("identifier = " + sectionID)) as ManagerSection;

    //     if (this.stockNote.status != StockNoteStatus.Processed) {
    //         let nextStatus = ad.selectedUser.checkAccessControlFlag(section.bitPosition, UserAccessControlBit.process) == false ? StockNoteStatus.Pending : StockNoteStatus.Processed;
    //         if (this.customStockNoteBeforeChangeStatus(nextStatus) == false) return;

    //         //set date if not found
    //         let now = MIODateNow();

    //         //SHOULD THESE TWO BE SWITCHED???
    //         if (this.stockNote.stockDate == null) this.stockNote.stockDate = now;
    //         this.stockNote.validationDate = now;

    //         if (this.stockNote instanceof InventoryNote) {
    //             this.checkIfCanProcessInventoryNote();
    //         }
    //         else {            
    //             this.changeProcessNoteStatus(nextStatus);
    //         }
    //     } 
    //     else {
    //         if (ad.selectedUser.checkAccessControlFlag(section.bitPosition, UserAccessControlBit.unprocess) == false) {
    //             AppHelper.showErrorMessage(null, "Info", "You don't have permission to unprocess this note");
    //             return;
    //         }

    //         this.showUnporcessAlert();
    //     }        
    // }

    // protected customStockNoteBeforeChangeStatus(status:number) : boolean {
    //     return true;
    // }

    // private updateUI(){
    //     MIONotificationCenter.defaultCenter().postNotification("StockNoteDidProcess", this.stockNote);
    // }

    // private showUnporcessAlert(){
    //     let avc = new MUIAlertViewController();
    //     avc.initWithTitle("Warning", "Are you sure you want to unprocess this document?", MUIAlertViewStyle.Default);

    //     avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("UNPROCESS", "UNPROCESS"), MUIAlertActionStyle.Destructive, this, function(){
    //         this.changeProcessNoteStatus(StockNoteStatus.Unprocessed);
    //     }));

    //     avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

    //     AppHelper.sharedInstance().presentViewController(avc, true);
    // }

    // private changeProcessNoteStatus(status:StockNoteStatus){
    //     this.stockNote.status = status;
    //     DBHelper.saveMainContextWithCompletion(this, function(this:NoteDetailHeaderView) {
    //         AppHelper.showInfoMessage(null, "Info", "The operation was sucessfull");
    //         this.updateUI();    
    //     });
    // }

    // private checkIfCanProcessInventoryNote(){

    //     let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
    //     ad.webService.canProcessStockNote(this.stockNote, this, function(this:NoteDetailHeaderView, data:any, error:string){
    //         if ( error == null || (error != null && error.length == 0) ) {
    //             this.changeProcessNoteStatus(StockNoteStatus.Processed);
    //         }
    //         else if (data != null && data.lenght > 0) {
    //             AppHelper.showErrorMessage(null, "Error", "Couldn't unprocess. The inventory (" + data[0]["sourceDocumentReference"] + ") must be unprocess first!");                
    //         }
    //         else {
    //             AppHelper.showErrorMessage(null, "Error", "Couldn't unprocess. " + error);                
    //         }
    //     });   

    // }
    
}